import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrimaryTradeForm } from 'src/app/classes/form-groups/primary-trade-form';
import { PrimaryTrade } from 'src/app/classes/models';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-trade-modal',
  templateUrl: './add-edit-trade-modal.component.html',
  styleUrl: './add-edit-trade-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditTradeModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ToastService: ToastService
  ) {}

  @Input() PrimaryTrade?: PrimaryTrade;

  primaryTradeForm: PrimaryTradeForm = new PrimaryTradeForm();
  tradeTiers: Map<string, number> = new Map([
    ['Level 1', 1],
    ['Level 2', 2],
    ['Level 3', 3]
  ]);

  keyPairOrder = this.UtilityService.keyValuePairDefaultOrder;

  tradeProfessionalismChange(
    field:
      | 'isProfessional'
      | 'isNonProfessional'
      | 'isProfessionalOrNonProfessional',
    value: boolean
  ) {
    if (['isProfessional', 'isNonProfessional'].includes(field) && value) {
      this.primaryTradeForm.patchValue({
        isProfessionalOrNonProfessional: false
      });
    }

    if (field === 'isProfessionalOrNonProfessional' && value) {
      this.primaryTradeForm.patchValue({
        isProfessional: false,
        isNonProfessional: false
      });
    }
  }

  close(reason?: string) {
    this.activeModal.dismiss(reason);
  }

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.primaryTradeForm
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. Form has errors.',
        { returnError: true }
      );
    }

    if (!this.PrimaryTrade) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. No Trade found.',
        { returnError: true }
      );
    }

    Object.assign(this.PrimaryTrade, this.primaryTradeForm.getRawValue());

    this.activeModal.close();
  }

  ngOnInit(): void {
    if (this.PrimaryTrade) {
      this.primaryTradeForm.patchValue(this.PrimaryTrade);
    }
  }
}
